module.exports = __webpack_public_path__ + "img/caret-down--dark.e07cce37.svg";